import React, { useContext, useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import dndIcon from "../../Assets/dndIcon.svg";
import add_icon_question from "../../Assets/add_icon_question.svg";
import settings_Icon_question from "../../Assets/settings_Icon_question.svg";
import image_icon_question from "../../Assets/image_icon_question.svg";
import section_icon_question from "../../Assets/section_icon_question.svg";
import trash_icon_question from "../../Assets/trash_icon_question.svg";
import { PageContext } from "../../Context/PageContext";
import PhoneQuestion from "../Questions/PhoneQuestion";
import EmailQuestion from "../AllQuestions/EmailQuestion";
import NumberQuestion from "../AllQuestions/NumberQuestion";
import SpinnerQuestion from "../Questions/SpinnerQuestion";
import SignatureQuestion from "../AllQuestions/SignatureQuestion";
import FileUploadQuestion from "../AllQuestions/FileUploadQuestion";
import AVFileUploadQuestion from "../AllQuestions/AVFileUploadQuestion";
import { useDispatch } from "react-redux";
import {
  deleteQuestion,
  updateRequiredChange,
} from "../../Redux/Reducer/FormSlices";
import DateAndTimeQuestion from "../Questions/DateAndTimeQuestion";
import DateQuestion from "../AllQuestions/DateQuestion";
import MultipleChoicegridQuestion from "../AllQuestions/MultipleChoiceGridQuestion";
import CheckBoxQuestion from "../AllQuestions/CheckBoxQuestion";
import DropDownQuestion from "../Questions/DropDownQuestion";
import ShortAnswerQuestion from "../AllQuestions/ShortAnswerQuestion";
import NameQuestion from "../AllQuestions/NameQuestion";
import ParagraphQuestion from "../AllQuestions/ParagraphQuestion";
import MultipleChoiceQuestion from "../AllQuestions/MultipleChoiceQuestion";
import LineScaleQuestion from "../AllQuestions/LineScaleQuestion";
import CheckBoxQuestionGridQuestion from "../AllQuestions/CheckBoxQuestionGridQuestion";
import WebsiteQuestion from "../AllQuestions/WebsiteQuestion";
import LocationQuestion from "../Questions/LocationQuestion";

const Items = ({
  id,
  question,
  questionIndex,
  containerIndex,
  colneQuestion,
  createNewSection,
  generalSettings,
}) => {
  const { attributes, listeners, setNodeRef } = useSortable({
    id: id,
    data: {
      type: "item",
    },
  });
  const toolbarOptions = [["bold", "italic", "underline"], ["link"]];
  const module = {
    toolbar: toolbarOptions,
  };

  const {
    openQuestion,
    setOpenQuestion,
    activeQuestion,
    setActiveQuestion,
    setOpenQuestionSetting,
    setActiveContainerIndex,
  } = useContext(PageContext);

  const openSetting = (question, containerIndex) => {
    setOpenQuestionSetting(question);
    setActiveContainerIndex(containerIndex);
  };

  const dispatch = useDispatch();

  const handleDeleteQuestion = (questionI, containerIndex) => {
    setOpenQuestionSetting(false);
    dispatch(deleteQuestion({ questionI, containerIndex }));
  };

  return (
    <div style={{ display: "flex", gap: "0.8rem" }}>
      <div
        key={question.id}
        className="QuestionContainer"
        ref={setNodeRef}
        {...attributes}
        style={{
          borderBottom: activeQuestion === question.id && "6px solid #1B51BB",
          boxShadow: activeQuestion === question.id && "3px 3px 32px 0 #bcb9b9",
        }}
        onClick={() => setActiveQuestion(question.id)}
      >
        <div className="dndIcon">
          <img src={dndIcon} alt="dndIcon" {...listeners} />
        </div>
        {renderItemComponent(
          question,
          module,
          questionIndex,
          openQuestion,
          setOpenQuestion,
          containerIndex,
          generalSettings
        )}
      </div>
      {activeQuestion === question.id && (
        <div className="container-right">
          <img
            src={add_icon_question}
            alt=""
            onClick={() => colneQuestion(question.type, containerIndex)}
          />
          <img
            src={settings_Icon_question}
            alt=""
            onClick={() => openSetting(question.id, containerIndex)}
          />
          <img
            src={image_icon_question}
            alt=""
            onClick={() => console.log("hello")}
          />
          <img
            src={section_icon_question}
            alt=""
            onClick={() => createNewSection(containerIndex, questionIndex)}
          />
          <img
            src={trash_icon_question}
            alt=""
            onClick={() => handleDeleteQuestion(questionIndex, containerIndex)}
          />
        </div>
      )}
    </div>
  );
};

const renderItemComponent = (
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
  generalSettings
) => {
  switch (question.type) {
    case "Short Answer":
      return (
        <ShortAnswerQuestion
          question={question}
          module={module}
          questionIndex={questionIndex}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          containerIndex={containerIndex}
          generalSettings={generalSettings}
        />
      );

    case "Name":
      return (
        <NameQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Paragraph":
      return (
        <ParagraphQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          containerIndex={containerIndex}
          id={question.id}
          generalSettings={generalSettings}
        />
      );
    case "Phone":
      return (
        <PhoneQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Multiple Choice":
      return (
        <MultipleChoiceQuestion
          question={question}
          module={module}
          questionIndex={questionIndex}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          containerIndex={containerIndex}
          id={question.id}
          generalSettings={generalSettings}
        />
      );
    case "Check box":
      return (
        <CheckBoxQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
          generalSettings={generalSettings}
        />
      );
    case "Email":
      return (
        <EmailQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          containerIndex={containerIndex}
        />
      );
    case "Dropdown":
      return (
        <DropDownQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Number":
      return (
        <NumberQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Line Scale":
      return (
        <LineScaleQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Date":
      return (
        <DateQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Multiple Choice grid":
      return (
        <MultipleChoicegridQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Check box grid":
      return (
        <CheckBoxQuestionGridQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );

    case "Website":
      return (
        <WebsiteQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Signature":
      return (
        <SignatureQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Audio/Video Upload":
      return (
        <AVFileUploadQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "File Upload":
      return (
        <FileUploadQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Spinner":
      return (
        <SpinnerQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );

    case "Date - Time":
      return (
        <DateAndTimeQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );
    case "Location":
      return (
        <LocationQuestion
          question={question}
          questionIndex={questionIndex}
          module={module}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
          id={question.id}
          containerIndex={containerIndex}
        />
      );

    default:
      return null;
  }
};
export default Items;
